import { Component, Input } from "@angular/core";
import { WidgetWithLinkAndExpandableDetails } from "../shared/widget-with-link-and-expandable-details";

@Component({
    selector: 'composite-widget',
    template: require('./composite-widget.component.html')
})
export class CompositeWidgetComponent extends WidgetWithLinkAndExpandableDetails {

    @Input() title: string;

    @Input() linkClickArea: LinkClickAreaType = LinkClickAreaType.WIDGET;

    @Input() description: string;

}

export enum LinkClickAreaType {
    WIDGET = "WIDGET",
    ICON = "ICON"
}